import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { cloneQuizRequested } from 'features/quizzes/actions';

export function* cloneQuizSaga(action: ReturnType<typeof cloneQuizRequested>) {
  yield call(SignalingSocket.send, { event: 'cloneQuiz', data: { id: action.payload } });
}
